enum MfaChannel {
  SMS = 'SMS',
  TOTP = 'TOTP',
  NONE = 'None',
  EMAIL = 'EMAIL',
}
export default MfaChannel
